class ScrollToTopButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
  }

  connectedCallback() {
    // Mostra/nasconde il bottone in base allo scroll
    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        this.button.style.display = 'flex';
      } else {
        this.button.style.display = 'none';
      }
    });

    // Scroll to top smooth
    this.button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}

// Registra il custom element
customElements.define('scroll-to-top-button', ScrollToTopButton);